import { useCallback } from 'react';
import { AnyTranslationKeys } from '~/common/types';

export function useErrorTranslation<TKeys extends string>(
  lookup: Record<TKeys, AnyTranslationKeys>,
) {
  const resolveErrorKey = useCallback(
    (code: string | undefined): AnyTranslationKeys =>
      code !== undefined
        ? (lookup[code as TKeys] ?? (code as AnyTranslationKeys))
        : ('' as AnyTranslationKeys),
    [lookup],
  );
  return {
    resolveErrorKey,
  };
}
